<div *ngIf="productData" class="productConsulta" [ngClass]="{
    preferred: productData && productData.preferred,
    discount:
      productData && !productData.preferred && productData.percentDiscount,
    shopWindowReduced: shopWindowReduced,
    'product-assinatura': isHybridPackageAssinatura
  }" (mouseenter)="onHover()" (mouseleave)="onLeave()" (click)="onClick()">
  <section class="header" [ngClass]="{
      empty:
        productData &&
        !(
          productData.preferred ||
          productData.percentDiscount ||
          isHybridPackageAssinatura
        ),
      headerDiscountSection: productData && !productData.preferred && productData.percentDiscount,
      headerPreferredSection: productData && productData.preferred,
      headerMonthlySubSection: isHybridPackageAssinatura
    }">
    <span *ngIf="
        productData.preferred ||
        productData.percentDiscount ||
        isHybridPackageAssinatura
      ">
      <p class="header-preferred" *ngIf="productData.preferred && !isHybridPackageAssinatura">Recomendado</p>
      <p class="header-monthlySub" *ngIf="isHybridPackageAssinatura">Assinatura mensal*</p>
      <p class="header-discount" *ngIf="!productData.preferred && productData.percentDiscount">
        Desconto de {{ productData.percentDiscount }}%
      </p>
    </span>
  </section>
  <section class="bodyExpanded" [ngClass]="{
      curveTop:
        productData &&
        !(
          productData.preferred ||
          productData.percentDiscount ||
          isHybridPackageAssinatura
        ),
      preferred: productData && productData.preferred,
      discount:
        productData && !productData.preferred && productData.percentDiscount,
      shopWindowReduced: shopWindowReduced,
      'product-assinatura': isHybridPackageAssinatura
    }">
    <div class="body" [ngClass]="{ open: dropdownOpened }">
      <div class="value">
        <section class="fullValue" [ngClass]="{empty: !productData.percentDiscount}">
          <span *ngIf="productData.percentDiscount"> De R$ {{formatCurrency(productData.baseValue)}} </span>
          <span *ngIf="productData.percentDiscount">por</span>
        </section>
        <section class="finalValue">
          <p>
            <ng-container *ngIf="productService.isVariableProduct(productData.product); else displayNormal">
              <div class="custom-value-wrapper" (click)="$event.stopPropagation()">
                <span>R$ </span>
                <input type="number" class="input-custom-value" value="{{customPackageValue}}"
                  [(ngModel)]="customPackageValue" (input)="updateCustomPackageValue($any($event.target).value)">
              </div>
            </ng-container>

            <ng-template #displayNormal>
              <span>R$ </span>
              <span class="integerPart">{{ productData.integerPart }}</span>
              <span class="decimalPart">,{{ productData.decimalPart === 0 ? '00' :
                (productData.decimalPart.toString().padEnd(2, '0')) }}</span>
            </ng-template>
          </p>
        </section>
      </div>
      <!-- <section class="bonus" [ngClass]="{
                'hasBonus': productData.extraBalanceValueSum > 0
            }">
        <span *ngIf="productData.extraBalanceValueSum > 0"><b> + R$
            {{formatCurrency(productData.extraBalanceValueSum)}}
          </b> <br>de bônus</span>
      </section> -->
      <!-- <section class="featuredTextSecion" *ngIf="productData.featuredText">
        <span class="featuredText" [ngClass]="{
            'featuredTextPurple': isHybridPackageAssinatura,
          }">{{ productData.featuredText }}</span>
      </section> -->
      <section class="buttons">
        <button class="buy"
          (click)="productService.isVariableProduct(productData.product) ? (checkCustomPackageValue() && onBuyClicked()) : onBuyClicked()">
          {{ textButton }}
        </button>
        <button class="drop" [ngClass]="{ colapse: dropdownOpened }" (click)="onDropClicked()">
          <img src="/assets/images/drop-down-icon.png" class="icon" />
        </button>
      </section>
    </div>

    <section class="featureList" [ngClass]="{ open: dropdownOpened }">
      <div class="featureItem" *ngFor="let feature of productData.featureList">
        <span><b>{{ feature.name }}</b></span>
        <span>{{ feature.toValue }}</span>
      </div>
    </section>
  </section>

</div>